// These are utility functions for array manipulations

/**
 * Chunk an array into smaller arrays of a specified size.
 *
 * @param array the array to be chunked
 * @param size the size of each chunk, default is 50
 * @template T the type of elements in the array
 * @returns an array of chunked arrays
 */
export const chunkArray = <T>(array: T[], size: number = 50): T[][] => {
  const chunkedArr: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    chunkedArr.push(array.slice(i, i + size));
  }
  return chunkedArr;
};
